import { useState, useMemo, useEffect } from "react";
import Form from "react-bootstrap/Form";

export default function CheckboxFilter({ options, selectedValues, onChange }) {
  const [search, setSearch] = useState("");
  const [checked, setChecked] = useState(selectedValues ?? []);

  // sync internal state when selectedValues is cleared externally (e.g. ResetFilterButton)
  useEffect(() => {
    if (!selectedValues || selectedValues.length === 0) {
      setChecked([]);
      setSearch("");
    }
  }, [selectedValues]);

  // Filter options by search
  const filteredOptions = useMemo(() => {
    return options.filter((o) =>
      o.label.toLowerCase().includes(search.toLowerCase()),
    );
  }, [options, search]);

  const handleChange = (newValues) => {
    setChecked(newValues);
    onChange(newValues);
  };

  const toggleValue = (value) => {
    const newValues = checked.includes(value)
      ? checked.filter((v) => v !== value)
      : [...checked, value];
    handleChange(newValues);
  };

  return (
    <div style={{ padding: "10px", width: "250px" }}>
      {/* Search input */}
      <Form.Control
        type="text"
        placeholder="Iskanje..."
        size="sm"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-2"
      />

      {/* Checkbox list */}
      <div style={{ maxHeight: "200px", overflowY: "auto" }}>
        {filteredOptions.map((opt) => (
          <Form.Check
            className="fs-6 text fw-light"
            key={opt.value}
            type="checkbox"
            label={opt.label}
            checked={checked.includes(opt.value)}
            onChange={() => toggleValue(opt.value)}
          />
        ))}
      </div>
    </div>
  );
}
